import { render } from "./Profile.vue?vue&type=template&id=2096ca0d"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=2096ca0d&lang=css"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__